module.exports = __webpack_public_path__ + "static/media/PorCobrar.c8b12eba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo/PorCobrar.svg
// module id = 634
// module chunks = 35